module.exports = __webpack_public_path__ + "static/media/16UNODC38.38554cb7.jpg";